import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

const DEFAULT_ODL_COUNT = 77;

export function useOdlCount(): number {
  const { data } = useQuery({
    queryKey: ['settings', 'odl_count'],
    queryFn: async () => {
      const { data } = await supabase
        .from('settings')
        .select('value')
        .eq('key', 'odl_count')
        .maybeSingle();
      const n = parseInt(data?.value ?? '', 10);
      return Number.isFinite(n) && n > 0 ? n : DEFAULT_ODL_COUNT;
    },
    staleTime: 5 * 60 * 1000,
  });
  return data ?? DEFAULT_ODL_COUNT;
}
